import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: '/wap',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeViewWap.vue'),
  },
  {
    path: "/NewsInside",
    name: "NewsInside",
    component: () => import("../views/NewsView/NewsInside.vue"),
  },
  {
    path: "/wap/NewsInside",
    name: "NewsInside",
    component: () => import("../views/NewsView/NewsInsideWap.vue"),
  },

  {
    path: "/BackEndAccount",
    name: "BackEndAccount",
    component: () => import("../views/BackEnd/BackEndAccount.vue"),
  },
  {
    path: "/NewsBackEnd",
    name: "NewsBackEnd",
    component: () => import("../views/BackEnd/NewsBackEnd.vue"),
  },
  {
    path: "/addNews",
    name: "addNews",
    component: () => import("../views/BackEnd/addNews.vue"),
  },
  {
    path: "/addCareer",
    name: "addCareer",
    component: () => import("../views/BackEnd/addCareer.vue"),
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../views/BackEnd/loginInside.vue"),
  },
  {
    path: "/CareerBackEnd",
    name: "CareerBackEnd",
    component: () => import("../views/BackEnd/CareerBackEnd.vue"),
  },
  {
    path: "/CareerInside",
    name: "CareerInside",
    component: () => import("../views/CareerView/CareerInside.vue"),
  },
  {
    path: "/wap/CareerInside",
    name: "CareerInside",
    component: () => import("../views/CareerView/CareerInsideWap.vue"),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutView.vue"
      ),
  },
  {
    path: "/wap/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutViewWap.vue"
      ),
  },
  {
    name: "certificates",
    path: "/about/certs",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutCerts.vue"
      ),
  },
  {
    name: "certificates",
    path: "/wap/about/certs",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutCertsWap.vue"
      ),
  },
  {
    name: "history",
    path: "/about/history",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutHistory.vue"
      ),
  },
  {
    name: "history",
    path: "/wap/about/history",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutHistoryWap.vue"
      ),
  },
  {
    name: "culture",
    path: "/about/culture",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutCulture.vue"
      ),
  },
  {
    name: "culture",
    path: "/wap/about/culture",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutCultureWap.vue"
      ),
  },
  {
    name: "team",
    path: "/about/team",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutTeam.vue"
      ),
  },
  {
    name: "team",
    path: "/wap/about/team",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutTeamWap.vue"
      ),
  },
  {
    name: "video",
    path: "/about/video",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutVideo.vue"
      ),
  },
  {
    name: "video",
    path: "/wap/about/video",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AboutView/AboutVideoWap.vue"
      ),
  },

  {
    path: "/product",
    name: "product",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ProductView/ProductView.vue"
      ),
  },

  {
    path: "/wap/product",
    name: "product",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ProductView/ProductViewWap.vue"
      ),
  },
  {
    name: "recycle",
    path: "/product/source",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ProductView/ProductRecycle.vue"
      ),
  },
  {
    name: "recycle",
    path: "/wap/product/source",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ProductView/ProductRecycleWap.vue"
      ),
  },
  {
    name: "case",
    path: "/wap/product/case",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ProductView/ProdUseCaseWap.vue"
      ),
  },
  {
    name: "case",
    path: "/product/case",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ProductView/ProdUseCase.vue"
      ),
  },
  {
    path: "/news",
    name: "news",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/NewsView/NewsView.vue"),
  },
  {
    path: "/wap/news",
    name: "news",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/NewsView/NewsViewWap.vue"),
  },
  {
    path: "/career",
    name: "career",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/CareerView/CareerView.vue"
      ),
  },
  {
    path: "/wap/career",
    name: "career",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/CareerView/CareerViewWap.vue"
      ),
  },
  {
    path: "/contact",
    name: "contact",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ContactUs.vue"),
  },
  {
    path: "/wap/contact",
    name: "contact",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ContactUsWap.vue"),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to,from,next)=>{
  if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) || (/Macintosh/.test(navigator.userAgent) && 'ontouchend' in document)){
    if(to.path.indexOf('/wap') == -1){
      router.push({
        path:'/wap' + to.path,
        query: to.query
      });
    }
  } else {
    if(to.path.indexOf('/wap') > -1){
      router.push({
        path:to.path.replace('/wap',''),
        query: to.query
      });
    }
  }
  let flag = sessionStorage.getItem('flag')       //获取点击登录按钮时所设置的 sessionStorage
  if(to.path === '/BackEndAccount'||to.path ==='/NewsBackEnd'||to.path ==='/AddNews'||to.path ==='/AddCareer'||to.path ==='/CareerBackEnd'){        //如果想要跳转页面必须判断有没有sessionStorage
    if(flag){              //如果有sessionStorage
      next();        //跳转
    }else {
      alert('您还没有登录，请先登录账户');   //没有就先登录
      next('/login')              //还在登录页
    }
  }
  else{
    next();
  }
  if(to.path === '/login'){        //如果跳转到了登录页面必须清空sessionStorage，否则在地址栏输入路径还是会跳转
    sessionStorage.clear();        //清空sessionStorage
  }
})

export default router
